// Mock data for Alan Shteynberg's Portfolio

export const personalInfo = {
  name: "Alan Shteynberg",
  title: "NOT JUST ANTIQUATED PLATITUDES",
  tagline: "I don't lift a finger on the keyboard unless I'm stacking millions of dollars — and that's exactly why this website was built using Speech-to-Text generative AI (Claude 4.5 Opus).\n\nIn other words, I'm broke. Let's work together — I can be trusted.",
  heroDescription: "I bring elegant form and function to create bottom-line benefit for my customers with domain knowledge and engaging, evergreen content.",
  email: "alan.shteynberg@gmail.com",
  phone: "215-470-2220",
  location: "Huntingdon Valley, PA",
  profileImage: "https://customer-assets.emergentagent.com/job_alans-resume/artifacts/vxzqwfvf_alan-shteynberg.jpg",
};

export const stats = [
  { value: "+15", label: "YEARS OF", sublabel: "EXPERIENCE" },
  { value: "+4", label: "PROJECTS", sublabel: "COMPLETED" },
  { value: "+5,500", label: "PACKS OF CIGARETTES", sublabel: "SMOKED" }
];

export const skillCards = [
  {
    id: 1,
    title: "SEO & CONTENT MARKETING, PAID ADS",
    type: "dark"
  },
  {
    id: 2,
    title: "GOOGLE ADS, AMAZON, EXCEL, ANALYTICS",
    type: "light"
  }
];

export const experiences = [
  {
    id: 1,
    company: "midpantry",
    role: "",
    duration: "2026",
    description: "In approaching Whiteheadian Concrescence; developed a model that deep-cleans, rotates, and resupplies commercial kitchens.\n\nThis model is the final touchpoint for a laterally derived existence consisting of matter found in the Periodic Table of Elements developed by Dmitri Mendeleev in 1869.\n\nThis model can be used across a variety of industry verticals to smooth the hysteresis error found in complex maintenence and sustainment processes and minimize unneccessary convolution.\n\nThis model is as nimble as it is elastic, and allows for the preservation of independent and private ownership for those with aptitude.",
  },
  {
    id: 2,
    company: "sygn",
    role: "Founder & Project Sherpa",
    duration: "2022 - 2023",
    description: "Tinkered in MadTech and developed a novel Out-of-Home (OOH) revenue share model that sought to aid in the funneling and distribution of surplus advertising budgets to over 1 million homeowners in the United States and Canada.",
  },
  {
    id: 3,
    company: "The HOTH",
    role: "Freelance Writer & SEO Specialist",
    duration: "2019 - 2021",
    description: "As a Google Certified Project Sherpa, I delivered SEO and content marketing campaigns for enterprise clients like Adobe Express and Google, as well as local, small business owners.",
  },
  {
    id: 4,
    company: "Crypto Answers",
    role: "Founder & Editor-in-Chief",
    duration: "Aug 2017 - Jan 2018",
    description: "Started a cryptocurrency blog that accrued 7,000+ followers and 35,000+ pageviews / month with $0 in ad spend.",
  },
  {
    id: 5,
    company: "FineLine Retail",
    role: "Co-Founder & COO",
    duration: "Aug 2012 - Dec 2016",
    description: "Co-founded an omnichannel eCommerce company. Launched 20+ private label products, shipped 150,000+ orders with 99% positive feedback, and generated ~$2M in Annual Gross Merchandise Volume (GMV).",
  }
];

export const projects = [
  {
    id: 1,
    title: "FineLine Retail",
    category: "Omni-Channel eCommerce",
    image: "/img/fineline-isometric.webp",
    link: "https://www.youtube.com/watch?v=9HxjMP5f5ZE"
  },
  {
    id: 2,
    title: "Crypto Answers",
    category: "Blog",
    image: "/img/crypto-isometric.webp",
    link: "https://www.youtube.com/watch?v=R1CBfyPQmcM"
  },
  {
    id: 3,
    title: "Project Sherpa",
    category: "Content and SEO",
    image: "/img/sherpa-isometric.webp",
    link: "https://www.youtube.com/watch?v=tPQcWfj9mcA"
  },
  {
    id: 4,
    title: "sygn",
    category: "Out of Home (OOH) Revenue Share Model",
    image: "/img/sygn-isometric.webp",
    link: "/sygn"
  },
  {
    id: 5,
    title: "midpantry",
    category: "The Food Service Industry Auxiliary Backbone",
    image: "/img/midpantry-isometric.webp",
    link: "https://midpantry.com/client-price-brief"
  }
];

export const tools = [
  { id: 1, name: "Google Ads", category: "Advertising", icon: "https://www.gstatic.com/images/branding/product/2x/ads_48dp.png" },
  { id: 2, name: "SEMrush", category: "SEO Tool", icon: "https://cdn.semrush.com/static/index/favicon.png" },
  { id: 3, name: "Analytics", category: "Data Platform", icon: "https://www.gstatic.com/analytics-suite/header/suite/v2/ic_analytics.svg" },
  { id: 4, name: "Excel", category: "Data Analysis", icon: "https://www.gstatic.com/images/branding/product/2x/sheets_48dp.png" },
  { id: 5, name: "Shopify", category: "E-Commerce", icon: "https://cdn.shopify.com/s/files/1/0533/2089/files/shopify-bag.png?v=1693603041" },
  { id: 6, name: "Amazon", category: "Marketplace", icon: "https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg" }
];

export const socialLinks = [
  { id: 1, name: "Instagram", url: "https://www.instagram.com/alan.shteynberg/" },
  { id: 2, name: "Twitter", url: "https://x.com/alan_shteynberg" },
  { id: 3, name: "LinkedIn", url: "https://www.linkedin.com/in/alan-shteynberg/" }
];
